module.exports = __webpack_public_path__ + "img/media-pharma-white.4e20c11c.png";